import React__default, { useMemo } from 'react';
import FALLBACK_LOCALIZED_TEXT from '../../translations-en.js';
import '../createContextUtilities/index.js';
import createContextUtilities from '../createContextUtilities/createContextUtilities.js';

const fallbackLocalizedText = FALLBACK_LOCALIZED_TEXT;
const {
  Provider: TranslationContextProvider,
  useContext: useTranslationContext
} = createContextUtilities({
  localizedText: {}
});
const TranslationProvider = _ref => {
  let {
    localizedText,
    children
  } = _ref;
  const translationContext = useMemo(() => ({
    localizedText
  }), [localizedText]);
  return /*#__PURE__*/React__default.createElement(TranslationContextProvider, {
    value: translationContext
  }, children);
};

export { TranslationProvider, fallbackLocalizedText, useTranslationContext };
